import { cn } from '@/lib/utils';
import { formatMoney } from '@/lib/currency';

interface MoneyCellProps {
  value: number | string;
  className?: string;
}

export function MoneyCell({ value, className }: MoneyCellProps) {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  const formatted = formatMoney(value);
  const isNegative = numValue < 0;

  return (
    <div
      className={cn(
        'text-right font-mono text-sm tabular-nums',
        isNegative && 'text-destructive',
        className,
      )}
    >
      {formatted}
    </div>
  );
}
